export const API_CONSTANTS = {
  //Common API for Dashboard Summary and Mnage View
  GetDashboard: '/api/V2/Actions/dashboard',
  GetViews: '/api/getViews',
  GetViewById: '/api/getViewById',
  GetActionCount: '/api/V2/Actions/actionCount',
  GetViewsWithFolders: '/api/getViewsWithFolders',
  GetChartInfo: '/api/V2/Actions/chartInfo',
  //Manage View API
  UpdateCustomQuery: '/api/updateQuery',
  AddViewToFavorites: '/api/addToFavoriteViews',
  RemoveViewFromFavorites: '/api/removeFromFavoriteViews',
  CreateTemporaryView: '/api/createTemporaryView',
  GetAllData: '/api/V2/Actions/getActionsToExport',
  MarkViewAsDefault: '/api/markAsDefault',
  DeleteUserView: '/api/deleteADOQueryById',
  DeleteFolder: '/api/deleteFolderById',
  SaveCustomQuery: '/api/saveQuery',
  CreateFolder: 'api/createFolder',
  PostUserRating: '/api/postUserRating',
  GetRatingConfig: '/api/getRatingConfig',
  GetUserRating: '/api/getUserRatings',
  GetDropdownData: '/api/getCosmosDropdownData',
  GetToolsName: '/api/getToolsName',
  GetAction: '/api/getAction',
  PersonDetails: '/api/Service/getPersonDetails',
  GetAlias: '/api/GetAlias',
  CheckAndAddUserToView: '/api/checkAndAddUserToView',
  GetAccountInfoFromTpID: '/api/v1/MSXData/GetAccountInfoFromTpID',
};

export const keepUnusedDataForConfig = 1800; // Cache data for 30 minutes (1800 seconds)
